import React, { useEffect, useRef, useState } from 'react'
import {
  Button,
  Drawer,
  Grid,
  IconButton,
  InputLabel,
  TextField,
  Typography,
  makeStyles,
  withStyles
} from '@material-ui/core'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import AsterTitleTypography from 'asterX-UI/Typography/AsterTitleTypography'
import ChevronLeftIcon from 'asterX-UI/Icons/ChevronLeftIcon'

import { useResErrors } from 'hooks'
import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'
import { BonusService } from 'lib/api/services/bonus.service'
import moment from 'moment/moment'
import { useSnackbar } from 'notistack'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import MaskedTextInput from 'asterX-UI/Inputs/MackedTextInput'
import { UnFrozeModal } from './UnFrozeModal'
import { AcUnit } from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 8
  },
  drawerPaper: {
    maxWidth: '550px'
  },
  closeButton: {
    color: theme.palette.grey[500]
  },
  wlViewTabs: {
    '& .Mui-selected': {
      color: PRIMARY_COLORS[700]
    },
    '& .MuiTabs-indicator': {
      backgroundColor: PRIMARY_COLORS[700]
    }
  },
  bonusTitle: {
    fontSize: 26,
    fontWeight: 600,
    textAlign: 'center'
  },
  bonusExpirationDate: {
    fontSize: 18,
    fontWeight: 500,
    textAlign: 'center'
  },
  bonusDescr: {
    fontSize: 18,
    fontWeight: 500,
    color: GRAY_COLORS[700]
  },
  bonusHistory: {
    border: `1px solid ${GRAY_COLORS[500]}`,
    borderRadius: 8,
    padding: 10,
    marginTop: 10,
    marginBottom: 20
  },
  bonusDate: {
    fontSize: 12,
    fontWeight: 500,
    color: GRAY_COLORS[600]
  },
  bonusInfo: {
    fontSize: 16,
    fontWeight: 500,
    color: GRAY_COLORS[700],
    display: 'flex',
    alignItems: 'center'
  }
}))

const DialogTitleCustom = withStyles()(props => {
  const classes = useStyles()

  const { children, onClose, ...other } = props
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={onClose}
      >
        <ChevronLeftIcon />
      </IconButton>
      <AsterTitleTypography label={children} />
    </MuiDialogTitle>
  )
})

const getTransaction = transactionType => {
  switch (transactionType) {
    case 'EARN':
      return '+'
    case 'SPEND':
      return '-'
    case 'TRANSFER_IN':
      return '+'
    case 'TRANSFER_OUT':
      return '-'
    case 'FROZEN':
      return <AcUnit fontSize="small" />
    case 'EXPIRE':
      return '-'
    default:
      return ''
  }
}

const getTransactionName = transactionType => {
  switch (transactionType) {
    case 'EARN':
      return 'Бонусы за покупку авто'
    case 'SPEND':
      return 'Потраченные бонусы'
    case 'FROZEN':
      return 'Замороженные бонусы'
    case 'TRANSFER_IN':
      return 'Полученные бонусы'
    case 'TRANSFER_OUT':
      return 'Отправленные бонусы'
    case 'EXPIRE':
      return 'Срок действия истек'
    default:
      return 'Бонусы'
  }
}

const getFieldsName = field => {
  switch (field) {
    case 'phoneNumber':
      return 'Номер телефона клиента'
    case 'currentPhoneNumber':
      return 'Отправитель бонусов'
    case 'transferPhoneNumber':
      return 'Получатель бонусов'
    case 'transferAmount':
      return 'Количество бонусов'
    case 'otpCode':
      return 'Код подтверждения'
    default:
      return '-'
  }
}

const BonusLine = ({ list, store, getBonuses }) => {
  const classes = useStyles()
  const { funcs } = useSelectionStore()

  const { enqueueSnackbar } = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)
  const intervalRef = useRef(null)

  const [otpCode, setOtpCode] = useState(null)
  const [transferAmount, setTransferAmount] = useState(null)

  const [openUnfrozeBonuses, setOpenUnrozeBonuses] = useState(false)

  const [useBonus, setUseBonus] = useState(false)
  const [transferBonus, setTransferBonus] = useState(false)
  const [currentPhoneNumber, setCurrentPhoneNumber] = useState(null)
  const [transferPhoneNumber, setTransferPhoneNumber] = useState(null)
  const [isOtpCodeSended, setIsOtpCodeSended] = useState(false)

  const [timer, setTimer] = useState(0)

  const clearData = () => {
    setOtpCode(null)
    setTransferAmount(null)
    setCurrentPhoneNumber(null)
    setTransferPhoneNumber(null)
    setIsOtpCodeSended(false)
    setTimer(0)
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }

  const getEightPercent = price => {
    const sumFrozenBonus = list?.totalFrozen
    const isEightPercent = price * 0.08
    if (sumFrozenBonus > isEightPercent) {
      return 0
    }
    return isEightPercent - sumFrozenBonus
  }

  const eightPercent = getEightPercent(store?.selectedCarForSale?.price)

  const handleUseBonus = async () => {
    setUseBonus(prev => !prev)
    clearData()
  }

  const handleTransfer = async () => {
    setTransferBonus(prev => !prev)
    clearData()
  }

  const postOtpCode = async phoneNumber => {
    if (!phoneNumber) {
      enqueueSnackbar('Нет номера', { variant: 'warning' })
      return
    }
    if (timer > 0) {
      enqueueSnackbar(`Доступно через ${timer} сек`, { variant: 'warning' })
      return
    }
    setIsLoading(true)
    try {
      const res = await BonusService.sendOtpCode(phoneNumber?.toNum())
      if (res?.data) {
        enqueueSnackbar('Код успешно отправлен!', { variant: 'success' })
        setIsOtpCodeSended(true)
        startTimer(setTimer)
      } else {
        enqueueSnackbar('Произошла ошибка! Повторите попытку!', {
          variant: 'error'
        })
        setIsOtpCodeSended(false)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  const startTimer = () => {
    let counter = 15
    intervalRef.current = setInterval(() => {
      setTimer(counter)
      if (counter === 0) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      } else {
        counter--
      }
    }, 1000)
  }

  const frozeBonuses = async () => {
    setIsLoading(true)
    try {
      const phoneNumber = store?.sale?.client?.phoneNumber?.toNum()

      const data = {
        phoneNumber: String(phoneNumber),
        otpCode,
        amount: transferAmount,
        workListId: store?.sale?.globalId,
        vin: store?.selectedCarForSale?.vin,
        projectCode: 'CS_AMP'
      }

      const requiredFields = { phoneNumber, transferAmount, otpCode }

      for (const [key, value] of Object.entries(requiredFields)) {
        if (!value) {
          enqueueSnackbar(`Недостаточно данных: ${getFieldsName(key)}`, {
            variant: 'warning'
          })
          setIsLoading(false)
          return
        }
      }

      if (transferAmount > eightPercent) {
        enqueueSnackbar(
          `Бонусы не могут превышать 8% от стоимости автомобиля или макс бонус`,
          {
            variant: 'warning'
          }
        )
        return
      }

      if (transferAmount > list?.totalAmount) {
        enqueueSnackbar(`Бонусы не могут превышать общее количество бонусов`, {
          variant: 'warning'
        })
        return
      }

      const dataDiscount = {
        discountReason: 'BONUS',
        discountValue:
          Number(store?.selectedCarForSale?.price) -
          Number(list?.totalFrozen) -
          Number(transferAmount),
        discountAmount: transferAmount || 0
      }

      const res = await BonusService.frozeBonus(data)
      if (res?.data) {
        enqueueSnackbar('Успешно!', { variant: 'success' })
        funcs.sendDiscountValue(dataDiscount, true)
        getBonuses()
        handleUseBonus()
      } else {
        enqueueSnackbar(`Произошла ошибка! ${res?.msg || res?.message || ''}`, {
          variant: 'error'
        })
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  const sendTransferBonus = async () => {
    setIsLoading(true)
    try {
      const data = {
        currentPhoneNumber: String(currentPhoneNumber?.toNum()),
        newPhoneNumber: String(transferPhoneNumber?.toNum()),
        transferAmount: transferAmount,
        otpCode: otpCode
      }

      const requiredFields = {
        currentPhoneNumber,
        transferPhoneNumber,
        transferAmount,
        otpCode
      }

      for (const [key, value] of Object.entries(requiredFields)) {
        if (!value) {
          enqueueSnackbar(`Недостаточно данных: ${getFieldsName(key)}`, {
            variant: 'warning'
          })
          setIsLoading(false)
          return
        }
      }

      const res = await BonusService.transferBonuses(data)
      if (res?.data) {
        enqueueSnackbar('Успешно!', { variant: 'success' })
        getBonuses()
        handleTransfer()
      } else {
        enqueueSnackbar(`Произошла ошибка! ${res?.msg || res?.message || ''}`, {
          variant: 'error'
        })
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Grid item container justifyContent="center" style={{ padding: 25 }}>
      <Grid item style={{ marginBottom: 20 }}>
        <Typography className={classes.bonusTitle}>{`${(
          list?.totalAmount || 0
        ).toLocaleString()} Б`}</Typography>
        {list?.expirationDate && (
          <Typography
            className={classes.bonusExpirationDate}
          >{`Срок действия: ${moment(list?.expirationDate).format(
            'DD.MM.yy'
          )}`}</Typography>
        )}
      </Grid>
      <Grid item xs={12} sm={12}>
        <Typography className={classes.bonusDescr}>
          История с бонусами
        </Typography>
      </Grid>
      <Grid
        item
        container
        display="flex"
        className={classes.bonusHistory}
        spacing={2}
        style={{ maxHeight: '500px', overflowY: 'auto' }}
      >
        {list && list?.transactions?.length ? (
          (list?.transactions || []).map(item => (
            <>
              <Grid item container xs={12} md={12}>
                <Typography className={classes.bonusDate}>
                  {moment(item?.transactionDate).format('DD.MM.yy HH:mm')}
                </Typography>
              </Grid>
              <Grid
                item
                container
                xs={6}
                md={6}
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid item>
                  <Typography className={classes.bonusInfo}>
                    {getTransactionName(item?.transactionType)}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                item
                container
                xs={6}
                md={6}
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid item>
                  <Typography className={classes.bonusInfo}>
                    {getTransaction(item?.transactionType)}
                    {` ${(item?.amount || 0).toLocaleString()} Б`}
                  </Typography>
                </Grid>
              </Grid>
            </>
          ))
        ) : (
          <Typography variant="h6" style={{ textAlign: 'center' }}>
            Нет данных
          </Typography>
        )}
      </Grid>
      <Grid item container spacing={2} style={{ marginBottom: 10 }}>
        {['BONUS'].includes(store?.selectedCarForSale?.discountReason) &&
          list?.totalFrozen > 0 && (
            <Grid item xs={12} md={12}>
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                disabled={false}
                onClick={() => setOpenUnrozeBonuses(true)}
              >
                Разморозить бонусы
              </Button>
            </Grid>
          )}
        <Grid item xs={12} md={6}>
          <Button
            variant="outlined"
            color="primary"
            fullWidth
            disabled={isLoading || useBonus}
            onClick={handleTransfer}
          >
            {transferBonus ? 'Закрыть трансфер' : 'Трансфер бонусов'}
          </Button>
        </Grid>
        {list?.totalAmount > 0 && !!store.sale.selectedCarsForSale && (
          <Grid item xs={12} md={6}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              disabled={isLoading || transferBonus}
              onClick={handleUseBonus}
            >
              {useBonus ? 'Закрыть бонусы' : 'Использовать бонусы'}
            </Button>
          </Grid>
        )}
      </Grid>

      {useBonus && (
        <Grid
          item
          container
          display="flex"
          justifyContent="flex-end"
          xs={12}
          md={12}
          spacing={2}
        >
          <Grid item xs={12} md={12}>
            <TextField
              fullWidth
              value={otpCode || ''}
              onChange={e => setOtpCode(e.target.value)}
              label={'Код...'}
              placeholder={'Код'}
            />
            <InputLabel shrink>
              Код подтверждения будет отправлен на номер телефона клиента
              <span
                onClick={() => postOtpCode(store?.sale?.client?.phoneNumber)}
                style={{
                  color: PRIMARY_COLORS[700],
                  cursor: 'pointer',
                  fontSize: 18,
                  fontWeight: 500
                }}
              >
                {`${
                  timer > 0
                    ? ` отправить еще раз ${timer} сек`
                    : ' отправить код'
                }`}
              </span>
            </InputLabel>
          </Grid>
          <Grid item xs={12} md={12}>
            <MaskedTextInput
              value={transferAmount}
              onChange={e => setTransferAmount(e.target.value)}
              mask="999999999"
              maskChar={false}
              fullWidth
              label="Количество бонусов"
            />
            <InputLabel shrink>{`макс бонус для использования ${eightPercent
              .toString()
              ?.thousandSeparator()} Б`}</InputLabel>
          </Grid>
          <Grid item xs={6} md={6}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              disabled={isLoading}
              onClick={frozeBonuses}
            >
              Подтвердить
            </Button>
          </Grid>
        </Grid>
      )}
      {transferBonus && (
        <Grid
          item
          container
          xs={12}
          md={12}
          justifyContent="flex-end"
          spacing={2}
        >
          <Grid item xs={12} md={12}>
            <MaskedTextInput
              value={currentPhoneNumber}
              onChange={e => setCurrentPhoneNumber(e.target.value)}
              mask="+7 (999) 999-99-99"
              fullWidth
              label="Номер отправителя"
            />
            <InputLabel shrink>
              Код подтверждения будет отправлен на номер телефона отправителя
              <span
                onClick={() => postOtpCode(currentPhoneNumber)}
                style={{
                  color: PRIMARY_COLORS[700],
                  cursor: 'pointer',
                  fontSize: 18,
                  fontWeight: 500
                }}
              >
                {`${
                  timer > 0
                    ? ` отправить еще раз ${timer} сек`
                    : ' отправить код'
                }`}
              </span>
            </InputLabel>
          </Grid>
          {isOtpCodeSended && (
            <>
              <Grid item xs={12} md={12}>
                <MaskedTextInput
                  value={transferPhoneNumber}
                  onChange={e => setTransferPhoneNumber(e.target.value)}
                  mask="+7 (999) 999-99-99"
                  fullWidth
                  label="Номер получателя"
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <MaskedTextInput
                  value={transferAmount}
                  onChange={e => setTransferAmount(e.target.value)}
                  mask="999999999"
                  maskChar={false}
                  fullWidth
                  label="Количество бонусов"
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <TextField
                  fullWidth
                  value={otpCode || ''}
                  onChange={e => setOtpCode(e.target.value)}
                  label={'Код...'}
                  placeholder={'Код'}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={isLoading}
                  onClick={sendTransferBonus}
                >
                  Подтвердить
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      )}
      <UnFrozeModal
        title={'Вы хотите разморозить бонусы?'}
        open={openUnfrozeBonuses}
        onClose={() => setOpenUnrozeBonuses(false)}
        onCancel={() => setOpenUnrozeBonuses(false)}
        getBonuses={getBonuses}
      />
    </Grid>
  )
}
const BonusHistory = ({ open, onClose }) => {
  const classes = useStyles()
  const { standardCheck } = useResErrors()
  const { store } = useSelectionStore()

  const [loading, setLoading] = useState(false)
  const [list, setList] = useState(null)

  useEffect(() => {
    if (open) {
      getBonuses()
    }
  }, [open])

  const getBonuses = async () => {
    setLoading(true)
    const data = {
      limit: 100,
      offset: 0,
      phoneNumber: store?.sale?.client?.phoneNumber?.toNum()
    }
    await BonusService.getBonuses(data).then(res =>
      standardCheck(
        res,
        () => {
          setList(res.data)
        },
        {
          textErr: 'Ошибка при получении бонусов'
        }
      )
    )
    setLoading(false)
  }

  return (
    <Drawer
      anchor="right"
      open={open}
      onClick={event => event.stopPropagation()}
      onClose={onClose}
      classes={{ paper: classes.drawerPaper }}
    >
      <DialogTitleCustom onClose={onClose}>Бонусы</DialogTitleCustom>{' '}
      {list ? (
        <BonusLine list={list} store={store} getBonuses={getBonuses} />
      ) : (
        <>
          <Typography
            variant="h6"
            style={{ textAlign: 'center', marginLeft: 20, marginRight: 20 }}
          >
            {loading ? 'Загружаем бонусы' : 'Нет бонусов'}
          </Typography>
        </>
      )}
    </Drawer>
  )
}

export default BonusHistory
